import { Component, Model, Prop, Vue } from 'nuxt-property-decorator';

import IconCheck from '../../assets/svg/check.svg';

@Component<CheckElement>({
  components: {
    IconCheck
  }
})
export default class CheckElement extends Vue {
  @Model('change')
  modelValue!: any;

  @Prop({ type: String, default: 'checkbox' })
  type!: 'checkbox' | 'tag' | 'radio';

  @Prop({ type: String })
  name!: string;

  @Prop({ type: String })
  label!: string;

  @Prop()
  value!: any;

  // State
  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  @Prop({ type: Boolean, default: false })
  required!: boolean;

  get isChecked(): boolean {
    if (this.modelValue instanceof Array) {
      return this.modelValue.includes(this.value);
    }

    return this.value !== undefined ? this.modelValue === this.value : this.modelValue;
  }

  updateInput(e: Event): void {
    if (this.type === 'radio') {
      this.$emit('change', this.value);
    } else {
      const isChecked = this.isChecked;

      if (this.modelValue instanceof Array) {
        const newValue = [...this.modelValue];

        if (isChecked) {
          newValue.splice(newValue.indexOf(this.value), 1);
        } else {
          newValue.push(this.value);
        }

        this.$emit('change', newValue);
      } else {
        if (this.value === undefined || typeof this.value === 'boolean') {
          this.$emit('change', !isChecked);
        } else {
          this.$emit('change', isChecked ? null : this.value);
        }
      }
    }
  }
}
